import { Component } from '@angular/core';
import { BoardService, AlertService } from 'app/services';
import _ from 'lodash';
import { REST_API_REQUEST_CALL_URL } from 'app/utils';

@Component({
  selector:'image-uploader',
  templateUrl: 'image-uploader.html'
})
export class AdminImageUploadComponent {
  fileData: File = null;
  folders: Array<ImageList> = [];
  showList: Array<boolean> = [];
  selectedImg: string = null;
  showImgModal:boolean = false;
  baseUrl:string = REST_API_REQUEST_CALL_URL.BASE_URL;

  constructor(private boardService: BoardService, private alertService:AlertService) { }

  ngOnInit() {
    this.getFileFolerList();
  }
  
  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
  }

  getFileFolerList() {
    this.boardService.getFileFolderList().subscribe(resp => {
      if(resp.result) {
        let folders = resp.data.sort((a, b)=>b-a);
        if(folders) {
          folders.map(folder => {
            this.folders.push({folderNm: folder, imageList: []});
            this.showList.push(false);
          }) 
        }
      }
    })
  }
 
  onSubmit() {
    const formData = new FormData();
    formData.append('imageFile', this.fileData);
    this.boardService.postImage(formData).subscribe(res => {
        this.alertService.success('이미지가 등록 되었습니다.');
    });
  }

  showImageList(folder, index) {
    this.showList[index] = !this.showList[index];
    if(_.isEmpty(folder.imageList)) {
      this.boardService.getImageList(folder.folderNm).subscribe(
        resp => {
          folder.imageList = resp.data;
        }
      )
    }
  }

  handleClickshowBig(img) {
    this.selectedImg = img;
    this.showImgModal = true;
  }

  imgModalclose() {
    this.showImgModal = false;
    this.selectedImg = null;
  }

  copyImageUrl(url) {
    const textArea = document.createElement("textarea");
    textArea.value = url;
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      successful && this.alertService.success('복사되었습니다.');
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
    document.body.removeChild(textArea);
  }
}

export class ImageList {
  folderNm: string;
  imageList: Array<string>;
}


// WEBPACK FOOTER //
// ./src/app/containers/board/image-uploader.ts